import ApiService from "@/api";
import { AdminModel, ResponseModel, SaveAdminsModel, UserModel } from "../models";
import {
  mapGetProjectsAdminsRequest,
  mapGetProjectsAdminsResponse,
  mapGetUsersAssignProjectAdminsResponse,
  mapSaveProjectsAdminsRequest,
} from "./AdapterServiceMappers";
import OwnedUsersRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/OwnedUsersRequest";
import EnumUserStatus from "@/api/Main/dataSource/api/users/base/enums/EnumUserStatus";

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * Получить список админов проекта
   * @param projetId ID проекта
   * @returns
   */
  getProjectAdmins(projetId: number) {
    return new Promise<ResponseModel<Array<AdminModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<AdminModel>>();

      await this.api.Main.PerformersListService.getAdminsListForProjectDetailAsync(
        mapGetProjectsAdminsRequest(projetId),
      )
        .then((resp) => {
          result.Value = mapGetProjectsAdminsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          console.error("ERROR getProjectAdmins", e);
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return resolve(result);
        });
    });
  }

  /**
   * Получить список пользователей для назначение админов проекта
   * @returns
   */
  getUsersAssignProjectAdmins() {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      const request = new OwnedUsersRequest({
        StatusList: [EnumUserStatus.Active],
        Search: "",
        Page: {
          Skip: 0,
          Take: 1000000,
        },
      });

      await this.api.Main.PerformersListService.getOwnedUsersAsync(request)
        .then((resp) => {
          result.Value = mapGetUsersAssignProjectAdminsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          console.error("ERROR getUsersAssignProjectAdmins", e);
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return resolve(result);
        });
    });
  }

  /**
   * Сохранить список админов проекта
   * @param request Запрос
   * @returns
   */
  saveProjectAdmins(request: SaveAdminsModel) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.ProjectAdminRoleService.upsertProjectAdminListAsync(
        mapSaveProjectsAdminsRequest(request),
      )
        .then((resp) => {
          result.Value = !!resp;
          result.IsSuccess = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          console.error("ERROR saveProjectAdmins", e);
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return resolve(result);
        });
    });
  }
}
